import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_User_Filter } from '../../../store/actions/CommanAction';
import DataTable from 'react-data-table-component';

const UserFilter = () => {
    const dispatch = useDispatch();
    const UserFilter = useSelector((state) => state.feedBackReducer.UserFilter);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

   
    useEffect(() => {
        
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;
    
        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;
    
        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);
    
       
        dispatch(get_User_Filter(formattedToday, formattedToday));
    }, [dispatch]);
    
    const handleSearch = () => {
        if (startTime && endTime) {
            
            const formatDateForAPI = (dateTime) => {
                const date = new Date(dateTime);
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };
    
            const formattedStartDate = formatDateForAPI(startTime);
            const formattedEndDate = formatDateForAPI(endTime);
    
            dispatch(get_User_Filter(formattedStartDate, formattedEndDate));
        } else {
            alert('Please select both Start Time and End Time');
        }
    };
    
    const columns = [
        { name: 'FirstName', selector: (row) => row.FirstName, sortable: true },
        { name: 'MobileNo', selector: (row) => row.MobileNo, sortable: true },
        { name: 'DOB', selector: (row) => row.DOB, sortable: true },
        { name: 'Gender', selector: (row) => row.Gender, sortable: true },
        { name: 'MaritalStatus', selector: (row) => row.MaritalStatus, sortable: true },
        { name: 'TOB', selector: (row) => row.TOB, sortable: true },
        { name: 'State', selector: (row) => row.State, sortable: true },
        { name: 'City', selector: (row) => row.City, sortable: true },
    ];

    return (
        <div>
            <div className="form-group">
                <div className="d-flex justify-content-between mt-3">
                    <div className="" style={{ flex: 1,marginRight: '-400px' }}>
                        <label>Start Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startTime}
                            style={{ width: '30%' }}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label>End Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endTime}
                            style={{ width: '30%' }}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                </div>
                <button className="btn btn-primary mt-3" onClick={handleSearch}>
                    Search
                </button>
            </div>

            <div className="col-12 mt-2">
                <DataTable
                    dense
                    data={UserFilter || []}
                    columns={columns}
                    selectableRowsHighlight
                    pagination
                    persistTableHead={true}
                    noDataComponent={"There are no data availble to display"}
                />
            </div>
        </div>
    );
};

export default UserFilter;

